import React from 'react';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';
import constants from 'Constants';
import * as paths from 'Paths';


const SubscriptionsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/control/subscriptions" */
    'routes/Control/Subscriptions/SubscriptionsRoute'
  )
));
const getControlSubscriptionsRoutes = () => {
  return [
    {path: paths.getPathControlSubscriptions(), component: SubscriptionsRoute},
  ]
}



export { getControlSubscriptionsRoutes };
